module.exports = __webpack_public_path__ + "img/empty.fc02d8e6.png";